module.exports = window["core-js/modules/es.array.filter.js"];